import React, { Component } from "react";
import { get as _get, isEqual as _isEqual, map as _map } from "lodash";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { showAlertMessage, Select, RenderTableHeaderValue, RenderTableCellValue, DateRangePicker, ConfirmBox, EmptyLabel } from "../../../resusableComponents/common/formElements";

import { withRouter } from "../../../resusableComponents/hoc/withRouter";
import ReactDataTable from "../../../resusableComponents/common/ReactDataTable";

import { getSavedSearchList, getHistoryData, deleteSavedSearch, getSearchTypeList } from "../../../redux/services/history";
import { getUserList } from "../../../redux/services/user";

import { updatePageLevelLoadingState } from "../../../redux/actions/application";
import { thousandSeparator } from "../../../helpers/utils";

class HistoryTab extends Component {

  constructor(props) {
    super(props);
    const { intl } = props;

    this.defaultPayload = {
      search_id: null,
      user_ids: null,
      search_type: null,
      start_date: "",
      end_date: "",
      page_no: 1,
      page_size: 100,
      orderby: "id",
      order: "desc"
    };

    this.state = {
      defaultPayload: { ...this.defaultPayload },
      userList: [],
      selectedUsers: null,
      searchTypeList: [],
      selectedSearchTypes: null,
      saveSearchList: [],
      selectedSearchId: null,
      page_no: 1,
      page_size: 100,
      historyData: {},
      activeRequestCount: 0,
      refreshTable: false,
      resetDateRangePicker: false,
      showDeleteConfirmBox: false,
      selectedSearchRowId: null
    };

    this.tableColumns = [
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.status", defaultMessage: "status" })} />),
        selector: (row) => (_get(row, "status_text", "")),
        cell: (row) => (<RenderTableCellValue className={_get(row, "color_code", "")} value={_get(row, "status_text", "")} />),
        sortable: true,
        sortField: "status_text",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.date", defaultMessage: "date" })} />),
        selector: (row) => (_get(row, "search_date", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "search_date", "")} />),
        sortable: true,
        sortField: "search_date",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.search_id", defaultMessage: "Search ID" })} />),
        selector: (row) => (_get(row, "id", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "id", "")} />),
        sortable: true,
        sortField: "id",
        grow: 0.6
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.search_name", defaultMessage: "search name" })} />),
        selector: (row) => (_get(row, "search_name", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "search_name", "")} />),
        sortable: true,
        sortField: "search_name",
        grow: 2
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.source", defaultMessage: "source" })} />),
        selector: (row) => (_get(row, "search_type", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "search_type", "")} />),
        sortable: true,
        sortField: "search_type",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.records", defaultMessage: "records" })} />),
        selector: (row) => (_get(row, "total_records", "")),
        cell: (row) => (<RenderTableCellValue value={thousandSeparator(_get(row, "total_records", 0))} />),
        sortable: false,
        sortField: "total_records",
        grow: 0.7
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.costs", defaultMessage: "costs" })} />),
        selector: (row) => (_get(row, "consumption_count", "")),
        cell: (row) => this._renderCostsTooltip(row, _get(row, "consumption_count", "")),
        sortable: false,
        grow: 0.8
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.criteria", defaultMessage: "criteria" })} />),
        selector: (row) => (_get(row, "search_filter_json", "")),
        cell: (row) => {
          let filterJson = {};
          try {
            filterJson = JSON.parse(JSON.parse(_get(row, "search_filter_json", "\"{}\"")));
          } catch (e) {
            console.error("Error parsing JSON:", e);
          }
          if (_get(row, "search_type", "") === "Apify Lead Search") {
            return this._renderApifyLeadSearchCriteriaTooltip(row, filterJson);
          }
          return this._renderCriteriaTooltip(row, filterJson);
        },
        sortable: false,
        grow: 0.8
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.user", defaultMessage: "user" })} />),
        selector: (row) => (_get(row, "username", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "username", "")} />),
        sortField: "user_id",
        sortable: false,
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.table.action", defaultMessage: "action" })} />),
        cell: (row) => {

          return (
            <Dropdown>
              <Dropdown.Toggle as="a" variant="link" className="fw-normal dropdown-toggle-no cursor-pointer">
                <img src={require("../../../assets/icons/icon-three-dot.svg").default} className="img-fluid" alt="img" />
              </Dropdown.Toggle>

              <Dropdown.Menu as="ul" className="dropdown-menu">
                <Dropdown.Item
                  as={Link}
                  to={`/history/saved-search/${_get(row, "id", 0)}`}
                  className="dropdown-item d-block waves-effect text-capitalize"
                >
                  <FormattedMessage id="btn.view" defaultMessage="view" />
                </Dropdown.Item>
                <Dropdown.Item className="dropdown-item d-block waves-effect text-capitalize" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ showDeleteConfirmBox: true, selectedSearchRowId: _get(row, "id", "") }) }}>
                  <FormattedMessage id="btn.delete" defaultMessage="delete" />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )
        },
        sortable: false,
        grow: 0.4,
        center: "true"
      },
    ];
  }

  componentDidMount() {
    this._fetchSearchTypeList();
    this._fetchUserList();
    this._fetchSaveSearchList();
    this._fetchHistoryData();
  }

  componentDidUpdate(prevProps, prevState) {

    if (
      (!_isEqual(prevState.defaultPayload, this.state.defaultPayload)) ||
      (!_isEqual(prevState.refreshTable, this.state.refreshTable) && (_get(this.state, "refreshTable", false) === true))
    ) {
      this._fetchHistoryData();
    }

    if (
      !_isEqual(prevState.defaultPayload, this.state.defaultPayload) &&
      (
        !_isEqual(_get(prevState, "defaultPayload.user_ids", null), _get(this.state, "defaultPayload.user_ids", null)) ||
        !_isEqual(_get(prevState, "defaultPayload.search_type", null), _get(this.state, "defaultPayload.search_type", null))
      )
    ) {
      this._fetchSaveSearchList();
    }
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchSearchTypeList = async () => {
    try {
      this._incrementLoader();

      const response = await getSearchTypeList();

      if ((response.flag || false) === true) {
        this.setState({ searchTypeList: _get(response, "data", []) });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching search types."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching search types."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchUserList = async () => {
    try {
      this._incrementLoader();

      const response = await getUserList();

      if ((response.flag || false) === true) {
        this.setState({ userList: _get(response, "data", []), selectedUsers: null });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching user list."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching user list."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchSaveSearchList = async () => {
    const { defaultPayload } = this.state;

    try {
      this._incrementLoader();

      const response = await getSavedSearchList({
        user_ids: (defaultPayload.user_ids || null),
        search_type: (defaultPayload.search_type || null)
      });

      if ((response.flag || false) === true) {
        this.setState({ saveSearchList: _get(response, "data", []), selectedSearchId: null });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching saved search list."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching saved search list."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchHistoryData = async () => {
    const { defaultPayload } = this.state;

    try {
      this._incrementLoader();

      const response = await getHistoryData({ ...defaultPayload });

      if ((response.flag || false) === true) {
        this.setState({ historyData: _get(response, "data", {}), refreshTable: false });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching history data."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching history data."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleSort = (column, sortDirection) => {
    this.setState((prevState) => {
      return {
        defaultPayload: {
          ...prevState.defaultPayload,
          page_no: 1,
          orderby: (column.sortField || column.selector || "id"),
          order: sortDirection
        }
      };
    });
  };

  _handleMultipleDelete = async () => {
    const { intl } = this.props;
    const { selectedSearchRowId } = this.state;

    if (!selectedSearchRowId) {
      showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one_with_operation", defaultMessage: "Please select at least one {field} to {operation}." }, {
        field: intl.formatMessage({ id: "history.label.saved_search", defaultMessage: "Saved Search" }),
        operation: intl.formatMessage({ id: "delete", defaultMessage: "delete" })
      }));
      return false;
    }

    try {
      this._incrementLoader();

      const response = await deleteSavedSearch({ search_ids: [(selectedSearchRowId || null)] });

      if (_get(response, "flag", false) === true) {
        showAlertMessage(_get(response, "message", "Saved search deleted successfully."), "success");

        this.setState({ showDeleteConfirmBox: false, selectedSearchRowId: null, refreshTable: true });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while deleting saved search."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while deleting saved search."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleResetFilters = () => {
    this.setState({
      defaultPayload: { ...this.defaultPayload },
      selectedUsers: null,
      selectedSearchTypes: null,
      saveSearchList: [],
      selectedSearchId: null,
      page_no: 1,
      page_size: 100,
      refreshTable: false,
      resetDateRangePicker: true,
      showDeleteConfirmBox: false,
      selectedSearchRowId: null
    });
  }

  _handleUpdateDateRange = (startDate, endDate) => {
    const { defaultPayload } = this.state;

    this.setState({
      defaultPayload: {
        ...defaultPayload,
        start_date: (startDate || ""),
        end_date: (endDate || "")
      },
      resetDateRangePicker: false
    });
  }

  _handlePaginationChange = (pageNo) => {
    const { defaultPayload } = this.state;

    this.setState({ defaultPayload: { ...defaultPayload, page_no: pageNo } });
  }

  _renderCostsTooltip = (row, consumptionCount = "") => {
    const costSources = JSON.parse(_get(row, "consumption_detail", "{}"));

    return (
      <>
        {(costSources || []).length <= 0 ? (
          <span className="text-dark text-capitalize text-italic cursor-not-allowed">
            <EmptyLabel />
          </span>
        ) : (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={`tooltip-${_get(row, "id", "")}`} className="custom-tooltip">
                <div className="criteria-tooltip-content cost-tooltip">
                  {_map(costSources, (cs, i) => {

                    return (
                      <div className="criteria-item cost-tooltip" key={`cost-source-${i}`}>
                        <span className="criteria-label">
                          {(cs.api || "")}:
                        </span>
                        <span className="criteria-value">
                          {(cs.consumption || "-")}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </Tooltip>
            }
          >
            <span className="text-primary text-capitalize cursor-pointer">
              <span className="me-2">{(consumptionCount || "")}</span>
              <img src={require("../../../assets/icons/icon-info.svg").default} className="img-fluid" alt="View" width="15" />
            </span>
          </OverlayTrigger>
        )}
      </>
    )
  }

  _renderCriteriaTooltip = (row, filterJson) => {
    const selectedJobSeniorityLength = (_get(filterJson, "selectedJobSeniority", []).length > 0);
    const selectedIndustryLength = (_get(filterJson, "selectedIndustry", []).length > 0);
    const selectedRegionCountryLength = (_get(filterJson, "selectedRegionCountry", []).length > 0);
    const selectedCompanySizeLength = (_get(filterJson, "selectedCompanySize", []).length > 0);
    const selectedRevenueLength = (_get(filterJson, "selectedRevenue", []).length > 0);
    const selectedDepartmentLength = (_get(filterJson, "selectedDepartment", []).length > 0);
    const uploadedFileName = _get(filterJson, "uploadedFileName", "");

    const hasValue = (selectedJobSeniorityLength || selectedIndustryLength || selectedRegionCountryLength || selectedCompanySizeLength || selectedRevenueLength || selectedDepartmentLength || uploadedFileName);

    return (
      <>
        {(!hasValue) ? (
          <span className="text-dark text-capitalize cursor-not-allowed">
            <FormattedMessage id="history.table.criteria.view" defaultMessage="view" />
          </span>
        ) : (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={`tooltip-${_get(row, "id", "")}`} className="custom-tooltip">
                <div className="criteria-tooltip-content">
                  {(selectedJobSeniorityLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.job_seniority" defaultMessage="Job Seniority" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "selectedJobSeniority", []).map(item => item.name).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(selectedIndustryLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.industry" defaultMessage="Industry" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "selectedIndustry", []).map(item => item.name).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(selectedRegionCountryLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.region_country" defaultMessage="Region/Country" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "selectedRegionCountry", []).map(item => item.name).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(selectedCompanySizeLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.company_size" defaultMessage="Company Size" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "selectedCompanySize", []).map(item => item.name).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(selectedRevenueLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.revenue" defaultMessage="Revenue" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "selectedRevenue", []).map(item => item.name).join(", ") || "-"}
                      </span>
                    </div>
                  )}

                  {(selectedDepartmentLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.department" defaultMessage="Department" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "selectedDepartment", []).map(item => item.name).join(", ") || "-"}
                      </span>
                    </div>
                  )}

                  {(uploadedFileName) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.uploaded_tal_file" defaultMessage="Uploaded TAL file" />:
                      </span>
                      <span className="criteria-value">
                        {(_get(filterJson, "uploadedFileName", "")) ? _get(filterJson, "uploadedFileName", "") : "-"}
                      </span>
                    </div>
                  )}
                </div>
              </Tooltip>
            }
          >
            <span className="text-primary text-capitalize cursor-pointer">
              <FormattedMessage id="history.table.criteria.view" defaultMessage="view" />
            </span>
          </OverlayTrigger>
        )}
      </>
    )
  }

  _renderApifyLeadSearchCriteriaTooltip = (row, filterJson) => {
    const companyIndustryLength = (_get(filterJson, "company_industry", []).length > 0);
    const contactLocationLength = (_get(filterJson, "contact_location", []).length > 0);
    const contactJobTitleLength = (_get(filterJson, "contact_job_title", []).length > 0);
    const emailStatusLength = (_get(filterJson, "email_status", []).length > 0);
    const seniorityLevelLength = (_get(filterJson, "seniority_level", []).length > 0);
    const sizeLength = (_get(filterJson, "size", []).length > 0);
    const functionalLevelLength = (_get(filterJson, "functional_level", []).length > 0);
    const companyDomainLength = (_get(filterJson, "company_domain", []).length > 0);

    const hasValue = (companyIndustryLength || contactLocationLength || contactJobTitleLength || emailStatusLength || seniorityLevelLength || sizeLength || functionalLevelLength || companyDomainLength);

    return (
      <>
        {(!hasValue) ? (
          <span className="text-dark text-capitalize cursor-not-allowed">
            <FormattedMessage id="history.table.criteria.view" defaultMessage="view" />
          </span>
        ) : (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={`tooltip-${_get(row, "id", "")}`} className="custom-tooltip">
                <div className="criteria-tooltip-content">
                  {(companyIndustryLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.company_industry" defaultMessage="Company Industry" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "company_industry", []).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(contactLocationLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.contact_location" defaultMessage="Contact Location" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "contact_location", []).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(contactJobTitleLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.contact_job_title" defaultMessage="Contact Job Title" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "contact_job_title", []).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(emailStatusLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.email_status" defaultMessage="Email Status" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "email_status", []).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(seniorityLevelLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.seniority_level" defaultMessage="Seniority Level" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "seniority_level", []).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(sizeLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.size" defaultMessage="Company Size" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "size", []).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(functionalLevelLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.functional_level" defaultMessage="Functional Level" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "functional_level", []).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                  {(companyDomainLength) && (
                    <div className="criteria-item">
                      <span className="criteria-label">
                        <FormattedMessage id="history.table.criteria.company_domain" defaultMessage="Company Domain" />:
                      </span>
                      <span className="criteria-value">
                        {_get(filterJson, "company_domain", []).join(", ") || "-"}
                      </span>
                    </div>
                  )}
                </div>
              </Tooltip>
            }
          >
            <span className="text-primary text-capitalize cursor-pointer">
              <FormattedMessage id="history.table.criteria.view" defaultMessage="view" />
            </span>
          </OverlayTrigger>
        )}
      </>
    )
  }

  _renderFilters = () => {
    const { intl } = this.props;
    const { userList, selectedUsers, saveSearchList, selectedSearchId, resetDateRangePicker, searchTypeList, selectedSearchTypes } = this.state;

    return (
      <div className="row">
        <div className="col-lg-3">
          <div>
            <label className="form-label text-capitalize">
              <FormattedMessage id="date_range_picker.title" defaultMessage="date range" />
            </label>
            <DateRangePicker resetDateRangePicker={(resetDateRangePicker || false)} onChange={(startDate, endDate) => this._handleUpdateDateRange(startDate, endDate)} />
          </div>
        </div>
        <div className="col-lg-2">
          <Select
            options={(userList || [])}
            getOptionLabel={(option) => (option.name || "")}
            getOptionValue={(option) => (option.id || null)}
            placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" },
              { field: intl.formatMessage({ id: "history.label.users", defaultMessage: "Users" }) })}
            label={intl.formatMessage({ id: "history.label.users", defaultMessage: "Users" })}
            value={(selectedUsers || null)}
            onChange={(value) => {
              this.setState((prevState) => ({
                selectedUsers: value, selectedSearchId: null, saveSearchList: [],
                defaultPayload: { ...prevState.defaultPayload, user_ids: value ? [(value.id || null)] : null, search_id: null }
              }));
            }}
            isMulti={false}
          />
        </div>
        <div className="col-lg-2">
          <Select
            options={(searchTypeList || [])}
            getOptionLabel={(option) => (option.search_type || "")}
            getOptionValue={(option) => (option.id || null)}
            placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" },
              { field: intl.formatMessage({ id: "history.label.source", defaultMessage: "Source" }) })}
            label={intl.formatMessage({ id: "history.label.source", defaultMessage: "Source" })}
            value={(selectedSearchTypes || null)}
            onChange={(value) => {
              this.setState((prevState) => ({
                selectedSearchTypes: value, selectedSearchId: null, saveSearchList: [],
                defaultPayload: { ...prevState.defaultPayload, search_type: value && value.length > 0 ? value.map(v => v.id) : null, search_id: null }
              }));
            }}
            isMulti={true}
          />
        </div>
        <div className="col-lg-3">
          <div>
            <Select
              options={(saveSearchList || [])}
              getOptionLabel={(option) => (option.search_name || "")}
              getOptionValue={(option) => (option.id || null)}
              placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" },
                { field: intl.formatMessage({ id: "history.label.saved_search", defaultMessage: "Saved Search" }) })}
              label={intl.formatMessage({ id: "history.label.saved_search", defaultMessage: "Saved Search" })}
              value={(selectedSearchId || null)}
              onChange={(value) => {
                this.setState((prevState) => ({
                  selectedSearchId: value, defaultPayload: { ...prevState.defaultPayload, search_id: value ? (value.id || null) : null }
                }));
              }}
              isMulti={false}
            />
          </div>
        </div>
        <div className="col-lg-2 d-flex justify-content-end align-items-end">
          <div className="mt-7">
            <button type="button" className="btn btn-dark waves-effect flex-fill text-capitalize" onClick={() => this._handleResetFilters()}>
              <FormattedMessage id="btn.reset" defaultMessage="Reset" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  _renderTableData = () => {
    const { historyData, defaultPayload } = this.state;

    return (
      <div className="row mt-2">
        <div className="col-lg-12">
          <div className="custom-scroll">
            <ReactDataTable
              className="custom-scroll-460"
              columns={(this.tableColumns || [])}
              data={_get(historyData, "saved-search", [])}
              fixedHeader={false}
              pagination={true}
              totalRecords={_get(historyData, "page_info[0].total_records", 0)}
              rowsPerPage={(defaultPayload.page_size || 100)}
              // selectableRows
              onChangePage={(e) => this._handlePaginationChange(e)}
              // onSelectedRowsChange={(selectedRows) => {
              //   const tmpIds = _get(selectedRows, "selectedRows", []).map(row => { return row.id });
              //   this.setState({ selectedIds: tmpIds });
              // }}
              sortServer
              onSort={(colm, order) => this._handleSort(colm, order)}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { intl } = this.props;
    const { showDeleteConfirmBox } = this.state;

    return (
      <>

        {this._renderFilters()}

        {this._renderTableData()}

        {showDeleteConfirmBox && (
          <ConfirmBox
            onConfirm={() => this._handleMultipleDelete()}
            isOpen={(showDeleteConfirmBox || false)}
            onClose={() => this.setState({ showDeleteConfirmBox: false, selectedSearchRowId: null })}
            content={intl.formatMessage({ id: "confirm.are_you_sure_delete", defaultMessage: "Are you sure want to delete {field}?" }, {
              field: intl.formatMessage({ id: "history.label.saved_search", defaultMessage: "Saved Search" })
            })}
          />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(injectIntl(HistoryTab)));
